<template>
  <div id="app">
    <site-header v-if="!testMode"></site-header>

    <router-view></router-view>
  </div>
</template>

<script>
  import SiteHeader from "@/components/site-header.vue"

  export default {
    name: "app",
    components: { SiteHeader },
    computed: {
      testMode() {
        return new URLSearchParams(window.location.search).get("wearejaws")
      }
    }
  }
</script>
